module.exports = "/_next/static/images/ConsistentData@2x-d822cfccd5d69229812aa0ee569bb9f8.png";